export default __webpack_public_path__ + "static/media/chevron_left.841e2261.svg";